var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xEB\\xCE\\xD3\\xC8_1",
    "data-name": "\\xEB\\xCE\\xD3\\xC8 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 317.2785,
    height: 241.6522,
    viewBox: "0 0 317.2785 241.6522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: 0.2;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #ebebeb;\n      }\n\n      .cls-4 {\n        fill: #fdcd02;\n      }\n\n      .cls-5 {\n        fill: #ebbf02;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.2043,149.103A76.9815,76.9815,0,0,0,152.4176,88.6908,46.6688,46.6688,0,0,0,114.54,69.322h0A46.7077,46.7077,0,0,0,68.5426,124.34a56.7917,56.7917,0,0,0-11.07,40.8522l-.1893.1894a38.3452,38.3452,0,1,0-5.66,76.27H271.0012a46.2748,46.2748,0,0,0,.2031-92.5492Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5394,62.2447a5.6131,5.6131,0,0,0,5.6132-5.6132V20.4149a5.6131,5.6131,0,1,0-11.2262,0V56.6315A5.613,5.613,0,0,0,114.5394,62.2447Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5456,78.0081A5.6131,5.6131,0,0,0,76.4834,70.07L50.8741,44.4605a5.6132,5.6132,0,0,0-7.9379,7.9385Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.89,121.6772H55.1069a5.6131,5.6131,0,0,0,0-11.2262H18.89a5.6131,5.6131,0,1,0,0,11.2262Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5647,79.652a5.5958,5.5958,0,0,0,3.9692-1.6439l25.609-25.6091a5.6133,5.6133,0,1,0-7.9384-7.9385L152.5955,70.07a5.6131,5.6131,0,0,0,3.9692,9.5823Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.9423,90.3221a57.1641,57.1641,0,0,0-77.1361,53.5435,57.6694,57.6694,0,0,0,.4089,6.7387,38.3488,38.3488,0,1,0-5.8685,76.2462H152.77l-.7578-159.6847A77.284,77.284,0,0,0,120.9423,90.3221Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.9273,134.3014A77.0126,77.0126,0,0,0,152.0124,67.1658l.7578,159.6847H257.7241a46.2748,46.2748,0,0,0,.2032-92.5491Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.52,101.2624a46.7421,46.7421,0,0,0,46.7421,46.7422V54.52A46.742,46.742,0,0,0,54.52,101.2624Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.6493,5.6131V41.83a5.613,5.613,0,0,0,5.6131,5.6132V0A5.613,5.613,0,0,0,95.6493,5.6131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.6493,160.6949v36.2168a5.6129,5.6129,0,0,0,5.6131,5.613V155.0818A5.6129,5.6129,0,0,0,95.6493,160.6949Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.2685,63.2064a5.6131,5.6131,0,0,0,7.9378-7.9385L37.597,29.6588a5.6132,5.6132,0,0,0-7.9379,7.9385Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.443,101.2624A5.613,5.613,0,0,0,41.83,95.6493H5.6132a5.6131,5.6131,0,1,0,0,11.2262H41.83A5.613,5.613,0,0,0,47.443,101.2624Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.2685,139.3185,29.6591,164.9276a5.6131,5.6131,0,1,0,7.9379,7.9383l25.6093-25.609a5.6131,5.6131,0,0,0-7.9378-7.9384Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M148.0045,101.2624A46.7421,46.7421,0,0,0,101.2624,54.52h0v93.4843h0A46.7422,46.7422,0,0,0,148.0045,101.2624Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.8754,41.83V5.6131A5.6131,5.6131,0,0,0,101.2624,0V47.4431A5.6131,5.6131,0,0,0,106.8754,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.8754,196.9117V160.6949a5.613,5.613,0,0,0-5.613-5.6131v47.4429A5.613,5.613,0,0,0,106.8754,196.9117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147.2568,139.3185a5.6133,5.6133,0,0,0-7.9384,7.9384l25.6091,25.609a5.6132,5.6132,0,0,0,7.9383-7.9383Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M196.9116,95.6493H160.6948a5.6131,5.6131,0,0,0,0,11.2262h36.2168a5.6131,5.6131,0,0,0,0-11.2262Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143.2875,64.85a5.596,5.596,0,0,0,3.9693-1.6439l25.609-25.6091a5.6133,5.6133,0,1,0-7.9383-7.9385L139.3184,55.2679a5.6132,5.6132,0,0,0,3.9691,9.5824Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunCloud);
export default __webpack_public_path__ + "static/media/sun-cloud.066686e2fd99a4ffc97b44c195938917.svg";
export { ForwardRef as ReactComponent };